module.exports = __webpack_public_path__ + "static/media/rio-de-janeiro-14.910697ee.jpg";